import * as Sentry from '@sentry/browser'; // eslint-disable-line import/no-namespace

const getWhitelistUrls = buildTarget => {
  if (buildTarget === 'server') {
    return undefined;
  }
  return [/ezcater\.com/];
};

const initialize = ({buildTarget, commitHash, dsn, environment}) => {
  Sentry.init({
    dsn,
    environment,
    release: commitHash,
    whitelistUrls: getWhitelistUrls(buildTarget),
    ignoreErrors: [/AbortError/],
  });
  Sentry.configureScope(scope => {
    scope.setTag('source', buildTarget);
  });
};

export default initialize;
